import React, { Component } from 'react';
import extensions from 'bulma-extensions';
import $ from 'jquery';

function InterestItem(props){
  var activeEle = props.title.indexOf('Machine') !== -1 ? 'carousel-item is-active' : 'carousel-item';
  return <div className={activeEle}>
          <div className="column">
            <div className="card has-background-black">
              <div className="card-content">
                <div className="content">
                  <div className="column has-text-white has-text-centered">
                    <p className="is-size-1 is-blue"><i className={props.icon}></i></p>
                  </div>
                  <div className="column has-text-white has-text-centered">
                    <p className="is-size-4">{props.title}</p>
                  </div>
                  <div className="column has-text-white has-text-centered">
                    <p className="is-size-6 has-text-weight-light">{props.description}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
}

function AllInterests(){
  const titles = ['Machine Learning & AI', 'Big Data Analytics', 'Computer Security', 'Software Design']
  const descriptions = [
    'Machine learning is a new technology that can create immense value to humankind. At the same time, it will challenge society. Not trying to understand how it works would be irresponsible.',
    'Big Data Analytics can substantially improve decision making, minimize risks, and discover valuable insights from the data that would otherwise remain hidden.', 
    'Cyber-attacks are not just in fiction movies, they are a reality of our world. The cost of cyber-attacks are estimated at $100 billion to $1 trillion annually. Cyber Security is now one of the biggest necessities of the world, because our lives revolve around computers', 
    'If you and I both understand that when I say \"Observer\", I am talking about a very specific structure of code, that means I can very quickly describe how a bit of code which uses that pattern works.']
  const icons = ['fas fa-brain', 'fas fa-server', 'fas fa-user-secret', 'fas fa-keyboard']
  return titles.map(function(title, i){
    return <InterestItem key={i} title={title} description={descriptions[i]} icon={icons[i]}/>
  })
}

class Interests extends Component {

  updateItems() {
    var deviceWidth = $(window).width();
    if(deviceWidth < 768)
      $('#interestsCarousel').attr('data-size', '1');
    else
      $('#interestsCarousel').attr('data-size', '4');
      
    var carousels = extensions.bulmaCarousel.attach();
  }

  componentDidMount(){
    this.updateItems();
    window.addEventListener("resize", this.updateItems.bind(this));
  }

  render() {
    return (
      <div id="interests">
      <div className="column has-text-centered">
        <p className="title is-5 is-blue has-text-bold is-heading padding-two-top">INTERESTS</p>
      </div>
      <div className="column has-text-centered">
        <p className="subtitle is-3 has-text-white has-text-bold">
          What are my interests?
        </p>
      </div>

      <div id='interestsCarousel' className='carousel carousel-animated carousel-animate-slide' data-size="4">
        <div className='carousel-container'>
          <AllInterests/>
        </div>
        <div className="carousel-navigation is-centered is-hidden-desktop">
          <div className="carousel-nav-left has-text-white">
            <i className="fa fa-chevron-left" aria-hidden="true"></i>
          </div>
          <div className="carousel-nav-right">
            <i className="fa fa-chevron-right has-text-white" aria-hidden="true"></i>
          </div>
        </div>
      </div>
    </div>
    );
  }
}

export default Interests;